<template>
<div class="container container-720">
  <h3>Select Account</h3>
  <Divider />
  <div class="list-group webcast-list" >
    <div class="list-group-item" style="padding-top: 25px; padding-bottom: 25px;" v-for="account in accountList" :key="account._id" v-bind:class="{active: $store.state.account.currentId == account._id}">
      <div @click="setAccount(account)">{{account.name}}</div>
      <div v-if="$store.state.auth.user.role=='admin'">
        <Button type="default" :to="'/account/'+account._id" style="position: absolute; right: 20px; top: 18px;">
            <Icon type="ios-create"></Icon>
            Edit
        </Button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      isSwitchPending: false,
      accountList: []
    }
  },
  computed: {
    ...mapGetters('account', {
      findAccountsFromStore: 'find'
    }),
    accounts() {
      return this.findAccountsFromStore({
        query: {
          $sort: {
            createdAt: 1
          }
        }
      }).data
    }
  },
  methods: {
    ...mapActions('account', {
      findAccounts: 'find',
      setCurrent: 'setCurrent'
    }),
    ...mapActions('user-permissions', {
      findPermissions: 'find',
    }),

    setAccount(account) {
      //return this
      this.setCurrent(account._id).then((response) => {
        this.$cookies.set('currentAccount', account._id)
        this.$router.replace("/");
      });
    }

  },
  created() {
    if(this.$store.state.auth.user.role == 'admin'){
      this.findAccounts({
        query: {
          $sort: {
            createdAt: 1
          }
        }
      }).then((acList)=>{
        this.accountList = acList.data;
      })
    } else {
      this.findPermissions({query:{userId: this.$store.state.auth.user._id}}).then((permList)=>{
        _.forEach(permList.data, (value, key)=>{
          this.accountList.push(value.account);
        });
      })

    }
  }
}
</script>

<style>

</style>
